module.exports = __webpack_public_path__ + "static/img/fileimg.32b8219.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/fileimg.png
// module id = rNk9
// module chunks = 1